import React from 'react'

function Skills({img, details, category, name}) {
  return (
    <div className="rounded-xl shadow-lg hover:shadow-xl cursor-pointer mb-10 sm:mb-0 h-fit hover:scale-105 transition-transform duration-300">    
       <img src={img} alt={name} className="rounded-tr-xl rounded-tl-xl border-none w-[309px] h-[139px]"/>
        <div className="text-center px-4 py-2">
          <div className="font-bold text-lg md:text-xl text-black my-2">{name}</div>
          <div className="text-lg font-semibold text-black/70">{category}</div>
          <div className="text-sm text-black/70   ">{details}</div>
        </div>
    </div>
  )
}

export default Skills